import Analytics = require('analytics-node');

import { v4 } from 'uuid';

export const getAnalyticsClient = (key: string) => {
  return new Analytics(key);
};

export const uuidv4 = () => v4();
